/**
 * Builds the [Label](url) link syntax that the integration service renders
 * into a real anchor in outgoing coach emails (emailBodyLinks.js on the
 * service side). The service only links http(s)/mailto targets, so the URL
 * is normalized to https:// here, and characters that would terminate the
 * (url) token — whitespace and parens — are percent-encoded.
 */

export function normalizeLinkUrl(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;

  let url = trimmed;
  if (!/^mailto:/i.test(url) && !/^https?:\/\//i.test(url)) {
    url = `https://${url}`;
  }
  url = url.replace(/\s/g, '%20').replace(/\(/g, '%28').replace(/\)/g, '%29');

  if (/^https?:\/\//i.test(url)) {
    // Require a host with a dot — catches "https://" alone and stray words.
    return /^https?:\/\/[^/]+\.[^/]{2,}/i.test(url) ? url : null;
  }
  return /^mailto:[^@\s]+@[^@\s]+\.[^@\s]+$/i.test(url) ? url : null;
}

export function buildLinkMarkdown(label: string, rawUrl: string): string | null {
  const url = normalizeLinkUrl(rawUrl);
  if (!url) return null;
  // Brackets/newlines would break the [Label] token on the service side.
  const cleanLabel = label.trim().replace(/[[\]\n]/g, '') || url;
  return `[${cleanLabel}](${url})`;
}
